import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-current-affair-details',
  templateUrl: './current-affair-details.component.html',
  styleUrls: ['./current-affair-details.component.scss']
})
export class CurrentAffairDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
